import React, { useState, useEffect, useMemo } from 'react';
import { API_ENDPOINTS } from 'core/constant/API_ENDPOINTS';
import { Alert } from 'react-bootstrap';
import useCrud from 'core/hooks/api/useCrud';
import FeatureSection from 'components/admin/common/FeatureSection';

const Information = () => {
    const { fetchData: productData } = useCrud(API_ENDPOINTS.PRODUCTS);
    const { fetchData: categoriesData } = useCrud(API_ENDPOINTS.FILTERS);
    const  [loading, setLoading] = useState(false);

    const {
        fetchData: obtenerHomeProductos,
        refetch: recargarHomeProductos,
        putData: actualizarHomeProducto,
        postData: crearHomeProducto,
        deleteData: eliminarHomeProducto,
        postError: creatingError,
        putError: updatingError,
    } = useCrud(API_ENDPOINTS.HOME_PRODUCTS);

    const {
        fetchData: obtenerHomeCategoriasPrincipales,
        refetch: recargarHomeCategoriasPrincipales,
        putData: actualizarHomeCategoriaPrincipal,
        postData: crearHomeCategoriaPrincipal,
        deleteData: eliminarHomeCategoriaPrincipal,
    } = useCrud(API_ENDPOINTS.HOME_MAIN_CATEGORIES);


    const productDataOptions = useMemo(() => {
        if (productData?.length > 0) {
            return productData?.map(product => ({
                label: product.title,
                value: product.id
            }));
        }
    }, [productData]);

    const categoriesDataOptions = useMemo(() => {
        if (categoriesData?.length > 0) {
            return categoriesData?.map(categories => ({
                label: categories.name,
                value: categories.id
            }));
        }
    }, [categoriesData]);

    const [errrorServer, setErrrorServer] = useState("");
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [products, setProducts] = useState([]);
    const [mainCategories, setMainCategories] = useState([]);

    useEffect(() => {
        setProducts(obtenerHomeProductos);
        setMainCategories(obtenerHomeCategoriasPrincipales);
    }, [obtenerHomeProductos,  obtenerHomeCategoriasPrincipales]);

    const handleFeatureChange = (index, key, value, setFeatures) => {
        setFeatures((prevFeatures) => {
            const newFeatures = [...prevFeatures];
            newFeatures[index] = { ...newFeatures[index], [key]: value };
            return newFeatures;
        });
    };

    const addFeature = (setFeatures) => {
        setFeatures((prevFeatures) => [...prevFeatures, { label: "", value: "" }]);
    };

    const removeFeature = (index, setFeatures, deleteFunction, featureId) => {
        setFeatures((prevFeatures) => {
            const newFeatures = [...prevFeatures];
            if (featureId) {
                deleteFunction(featureId);
            }
            return newFeatures.filter((_, i) => i !== index);
        });
    };

    const handleSave = async () => {
        setSuccessMessage(null);
        setErrrorServer(null);
        setLoading(true);

        try {
            for (const product of products) {
                if (product.id) {
                    await actualizarHomeProducto(product.id, product);
                } else {
                    await crearHomeProducto({ ...product, home_id: 1 });
                }
            }

            for (const category of mainCategories) {
                if (category.id) {
                    await actualizarHomeCategoriaPrincipal(category.id, category);
                } else {
                    await crearHomeCategoriaPrincipal({ ...category, home_id: 1 });
                }
            }

            setSuccessMessage("Información guardada con éxito.");
            setErrors({});
            recargarHomeProductos();
            recargarHomeCategoriasPrincipales();
        } catch (error) {
            setErrrorServer("No puede haber datos vaciós")
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="row w-100 mb-2">
                <div className="p-0 sub-title Service mb-2">
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <h5 className="m-0 text-title">Patina Principal</h5>
                        <button className="btn btn-primary" onClick={handleSave}>
                            <i className="fa fa-save me-2" aria-hidden="true" />
                            {loading ? "Guardando..." : "Guardar Cambios"}
                        </button>
                    </div>
                </div>
                <hr className="mx-0" style={{ border: '2px', margin: '5px' }} />
            </div>
            {successMessage && <Alert variant="success">{successMessage}</Alert>}
            {errrorServer && <Alert variant="danger">{errrorServer}</Alert>}
            <FeatureSection
                title="Categorías Principales"
                features={mainCategories}
                setFeatures={setMainCategories}
                options={categoriesDataOptions}
                handleFeatureChange={handleFeatureChange}
                addFeature={addFeature}
                removeFeature={(index) => removeFeature(index, setMainCategories, eliminarHomeCategoriaPrincipal, mainCategories[index]?.id)}
                errors={errors}
                name="filter_id"
            />
            <FeatureSection
                title="Productos"
                features={products}
                setFeatures={setProducts}
                options={productDataOptions}
                handleFeatureChange={handleFeatureChange}
                addFeature={addFeature}
                removeFeature={(index) => removeFeature(index, setProducts, eliminarHomeProducto, products[index]?.id)}
                errors={errors}
                name="product_id"
            />
        </div>
    );
};

export default React.memo(Information);